import MapPublicRoutes from 'js/vue-plugins/vue-router/routes/municipalities/map-public-routes' // OK
import PublicRoutes from 'js/vue-plugins/vue-router/routes/municipalities/public-routes' // OK
import PrivateRoutes from 'js/vue-plugins/vue-router/routes/municipalities/private-routes' // OK

import Municipality from 'js/pages/municipality/index.js'

export default {
  path: '/:country/:municipality',
  name: 'municipality',
  component: Municipality,
  redirect: { name: HOME_ROUTE },
  children: [
    ...normalizeRoutes(MapPublicRoutes),
    ...normalizeRoutes(PublicRoutes),
    ...normalizeRoutes(PrivateRoutes)
  ]
}
